import { mapGetters } from 'vuex'
import Paginate from 'vuejs-paginate'
import Status from '@/components/status'
import swal from 'sweetalert'
import Create from '../create'
import Update from '../update'

export default {
  name: 'list',
  components: {Paginate, Status, Create, Update},
  props: [],
  data () {
    return {
      per_page: 100,
      page: 1
    }
  },
  computed: {
    ...mapGetters({
      group_faqs: 'GroupFAQ/getListGroupFAQ',
      last_page: 'GroupFAQ/getLastPage',
      total: 'GroupFAQ/getTotal',
      options: 'Status/getStatusCheckerMaker'
    })
  },
  mounted () {
    this.$loading.start()
    Promise.all([
      this.$store.dispatch('GroupFAQ/getListGroupFAQ', {page: this.page, per_page: this.per_page}),
      this.$store.dispatch('Status/getListStatus')
    ]).then(res => {
      this.$loading.complete()
    }).catch(errors => {
      this.$loading.fail()
    })
  },
  methods: {
    changeTotal () {
      this.$loading.start()
      Promise.all([
        this.$store.dispatch('GroupFAQ/getListGroupFAQ', {page: this.page, per_page: this.per_page})
      ]).then(res => {
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    },
    changePage (page) {
      this.page = page
      this.$loading.start()
      Promise.all([
        this.$store.dispatch('GroupFAQ/getListGroupFAQ', {page: this.page, per_page: this.per_page})
      ]).then(res => {
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    },
    approval (group_faq = {}) {
      this.$loading.start()
      this.$store.dispatch('GroupFAQ/approvalGroupFAQ', {group_faq}).then(res => {
        group_faq.status = res.status
        this.$loading.complete()
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
      }).catch(errors => {
        this.$loading.fail()
      })
    },
    rejection (group_faq = {}) {
      this.$loading.start()
      this.$store.dispatch('GroupFAQ/rejectGroupFAQ', {group_faq}).then(res => {
        group_faq.status = res.status
        this.$loading.complete()
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
      }).catch(errors => {
        this.$loading.fail()
      })
    },
    destroy (group_faq = {}) {
      swal({
        title: this.$t('notify.delete_comfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
            this.$loading.start()
            this.$store.dispatch('GroupFAQ/destroyGroupFAQ', {
              group_faq
            }).then((res) => {
              this.$notify({
                group: 'success',
                title: this.$t('notify.notify'),
                text: this.$t('notify.delete_success')
              })
              this.$store.dispatch('GroupFAQ/getListGroupFAQ', {page: this.page, per_page: this.per_page})
              this.$loading.complete()
            }).catch(errors => {
              this.$loading.complete()
            })
          }
        })
    },
    create () {
      this.$refs.create.show()
    },
    edit (group_faq = {}) {
      this.$loading.start()
      this.$store.dispatch('GroupFAQ/showGroupFAQ', {group_faq}).then(res => {
        this.$refs.update.show(res)
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    },
    createSuccess (group_faq = {}) {
      this.$store.dispatch('GroupFAQ/getListGroupFAQ', {page: this.page, per_page: this.per_page}).then(res => {
        this.$refs.create.hide()
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.create_success')
        })
      })
    },
    updateSuccess (group_faq = {}) {
      this.$store.dispatch('GroupFAQ/getListGroupFAQ', {page: this.page, per_page: this.per_page}).then(res => {
        this.$refs.update.hide()
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/group-faq/list/list.js